var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiscellaneousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3993 0.352685C13.6882 0.305859 13.0868 0.871985 13.0868 1.58242V9.68324C13.0868 10.3629 13.6378 10.9133 14.3168 10.9133H22.4177C23.1281 10.9133 23.6942 10.3118 23.6474 9.60077C23.3204 4.643 19.3574 0.679687 14.3993 0.352685ZM22.3451 9.61329C22.0289 5.36446 18.6358 1.97113 14.3868 1.65499V9.61329H22.3451Z",
    fill: "#383634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67131 14.3402C1.33903 9.52197 4.96595 5.47547 9.62288 5.12878V13.1478C9.62288 13.8267 10.1734 14.3773 10.8524 14.3773H18.8717C18.758 15.9038 18.247 17.3189 17.4415 18.5211C17.2417 18.8194 17.3215 19.2231 17.6198 19.4229C17.918 19.6227 18.3217 19.5429 18.5216 19.2447C19.464 17.838 20.0568 16.1764 20.1742 14.3858C20.2208 13.6724 19.6501 13.0773 18.9453 13.0773H10.9229V5.05512C10.9229 4.35118 10.3287 3.77917 9.61464 3.82619C4.21248 4.1805 -0.00987861 8.85756 0.374393 14.4297C0.712071 19.326 4.67417 23.2881 9.57049 23.6258C11.9249 23.7882 14.1228 23.1272 15.9008 21.9007C16.1963 21.6969 16.2706 21.2921 16.0668 20.9966C15.8629 20.7011 15.4582 20.6268 15.1627 20.8306C13.6188 21.8955 11.7112 22.4703 9.65995 22.3288C5.41109 22.0358 1.96434 18.5891 1.67131 14.3402Z",
    fill: "#383634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneousIcon);
export default __webpack_public_path__ + "static/media/miscellaneous_icon.ba408212c3e9145930467dc0fc61d698.svg";
export { ForwardRef as ReactComponent };